import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { Console } from "console";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { config } from "process";
import { IBillingShippingModel } from "../../../interfaces/LicenseModel";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./generate-service360-license.component.html'),
    styles:[require('./generate-service360-license.component.css')],
    selector:'generate-service360-license'
})
export class GenerateService360LicenseComponent{
    dialogTitle='';
    errorMessage='';
    service360LicenseForm:FormGroup
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    isBillingShippingDetailFetched=false;
    customerId=0;
    shippingAddressId=0;
    shouldFetchSalesOrderNo=false;
    Service360LicenseDisplayList;
    SelectedLicenseDetail;
    error=""
    prevSalesOrderNo='';
    constructor(
        private dialogRef:MdDialogRef<GenerateService360LicenseComponent>,
        private formBuilder:FormBuilder,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private snackBar:MdSnackBar,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData: any
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.Service360LicenseDisplayList=this.dialogData.Service360LicenseData;
        this.SelectedLicenseDetail=this.dialogData.SelectedLicenseDetail;
        if(this.SelectedLicenseDetail){
            this.dialogTitle="Edit License Request";
            this.service360LicenseForm.patchValue({
                NoOfInstallation:this.SelectedLicenseDetail.NoOfInstallation,
                SalesOrderNo:this.SelectedLicenseDetail.SalesOrderNo,
            })
            this.isBillingShippingDetailFetched=true;
            this.prevSalesOrderNo=this.SelectedLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName=this.SelectedLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedLicenseDetail.ShipToState;
        }
        else{
            this.dialogTitle='Generate New License Request';
        }
        
    }
    buildForm(){
        this.service360LicenseForm=this.formBuilder.group({
            NoOfInstallation:[,[Validators.required,Validators.max(100)]],
            SalesOrderNo:['',[Validators.required]]
        })
    }
    blurSalesOrderEvent(){
        if(this.prevSalesOrderNo.trim().toUpperCase()==this.service360LicenseForm.value.SalesOrderNo.trim().toUpperCase()){
            return;
        }
        this.prevSalesOrderNo=this.service360LicenseForm.value.SalesOrderNo
        setTimeout(() => {
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
        }, 150);
    }
    
    checkSalesOrderNo(){
        if(this.dialogData.Service360LicenseData){
            let exist=this.dialogData.Service360LicenseData.some(element => {
                if(element.SalesOrderNo!=null){
                    return this.service360LicenseForm.value.SalesOrderNo.trim().toUpperCase()==element.SalesOrderNo.trim().toUpperCase()
                }
                else{
                    return false
                }
            });
            if(exist){
                Swal.fire({
                    title:"This sales order no already exists",
                    text:"Are you sure you want to use this Sales Order No?",
                    showCancelButton:true,
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonText:"Yes",
                    confirmButtonColor:"#FFCA28",
                    cancelButtonText:"No",
                }).then((result)=>{
                    if(result.isConfirmed){
                       this.shouldFetchSalesOrderNo=true;
                       this.isBillingShippingDetailFetched=false;
                       this.getBillingShippingDetail()
                    }
                    else{
                        this.shouldFetchSalesOrderNo=false;
                        this.isBillingShippingDetailFetched=false
                        this.service360LicenseForm.patchValue({
                            SalesOrderNo:""
                        });
                    }
                })
            }
            else{
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
                this.getBillingShippingDetail()
            }
        }
        else{
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
            this.getBillingShippingDetail()
        }
    }
    getBillingShippingDetail(){
        let salesOrderNo=this.service360LicenseForm.value.SalesOrderNo;
        console.log(salesOrderNo)
        if(salesOrderNo!=''){
            if(this.shouldFetchSalesOrderNo){
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        this.billingShippingDetail=data.DataObject;
                        this.isBillingShippingDetailFetched=true;
                        this.error='';
                    }
                    else{
                        this.isBillingShippingDetailFetched=false;
                        this.error=data.Error;
                    }
                    this.appLoader.close();
                })
            }
            else{
                this.error="Please select other sales order number."
            }
        }
        else{
            this.error="Sales Order No is required";
            this.isBillingShippingDetailFetched=false;
        }
    }
    onSave(){
        setTimeout(() => {
            if(!this.isBillingShippingDetailFetched){
                this.error="Please fetch the customer billing and shipping details!";
                return;
            }
            if(this.SelectedLicenseDetail!=null){
                this.appLoader.open();
                if(this.SelectedLicenseDetail.SalesOrderNo!=this.service360LicenseForm.value.SalesOrderNo){
                    this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((response)=>{
                        if(!response.IsError && response.DataObject!=null){
                            let model={
                                LicenseId:this.SelectedLicenseDetail.LicenseId,
                                CustomerId:response.DataObject.CustomerId,
                                ShippingAddressId:response.DataObject.ShippingAddressId,
                                NoOfInstallation:this.service360LicenseForm.value.NoOfInstallation,
                                SalesOrderNo:this.service360LicenseForm.value.SalesOrderNo,
                                UpdatedBy:Number(localStorage.getItem('userid'))
                            }
                            this.licenseService.updateService360License(model).subscribe((data)=>{
                                if(!data.IsError && data.DataObject!=null){
                                    this.Service360LicenseDisplayList=data.DataObject;
                                    this.dialogRef.close(this.Service360LicenseDisplayList);
                                    this.appLoader.close();
                                    this.snackBar.open("License Updated successfully!","",{
                                        duration:2000
                                    })
                                }
                                else{
                                    this.appLoader.close();
                                    this.dialogRef.close(this.Service360LicenseDisplayList);
                                }
                            })
                        }
                    })
                }
                else{
                    let model={
                        LicenseId:this.SelectedLicenseDetail.LicenseId,
                        CustomerId:this.SelectedLicenseDetail.CustomerId,
                        ShippingAddressId:this.SelectedLicenseDetail.ShippingAddressId,
                        NoOfInstallation:this.service360LicenseForm.value.NoOfInstallation,
                        SalesOrderNo:this.service360LicenseForm.value.SalesOrderNo,
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    this.licenseService.updateService360License(model).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.Service360LicenseDisplayList=data.DataObject;
                            this.dialogRef.close(this.Service360LicenseDisplayList);
                            this.appLoader.close();
                            this.snackBar.open("License Updated successfully!","",{
                                duration:2000
                            })
                        }
                        else{
                            this.appLoader.close();
                            this.dialogRef.close(this.Service360LicenseDisplayList);
                        }
                    })
                }
            }
            else{
                this.appLoader.open();
                this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                    let model={
                        CustomerId:data.DataObject.CustomerId,
                        ShippingAddressId:data.DataObject.ShippingAddressId,
                        NoOfInstallation:this.service360LicenseForm.value.NoOfInstallation,
                        SalesOrderNo:this.service360LicenseForm.value.SalesOrderNo,
                        CreatedBy:Number(localStorage.getItem('userid')),
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    if(!data.IsError && data.DataObject!=null){
                        this.customerId=data.DataObject.CustomerId;
                        this.shippingAddressId=data.DataObject.ShippingAddressId;
                        this.licenseService.generateService360License(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.Service360LicenseDisplayList=data.DataObject;
                                this.appLoader.close();
                                this.dialogRef.close(this.Service360LicenseDisplayList);
                                this.snackBar.open("License generated successfully!","",{
                                    duration:2000
                                })
                            }
                            else{
                                this.appLoader.close();
                                this.dialogRef.close(this.Service360LicenseDisplayList);
                            }
                        });
                    }
                });
            }  
        }, 300);
        
    }
    onCancel(){
        this.dialogRef.close(this.Service360LicenseDisplayList);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/service360/generate-service360-license/generate-service360-license.component.ts